export const DEAL_TYPE_PARAM = 'dealType';
